export const aboutData = {
  title: "Who I am",
  description1:
    " Hi Everyone, I am Bulbul Tomar from Indore, India. I have completed my Bachelor of Computer Application (BCA) at Renaissance University, Indore. ",
  description2:
    "I fell in love with programming and have learned quite a bit along the way. My field of interest lies in building new web technologies. Whenever possible, I apply my passion for developing products using Node.js and modern JavaScript libraries and frameworks like React.js and Next.js. ",
  image: 2
};
 